import { gql } from '@apollo/client';
const REMOVE_CHANNEL = gql `
  mutation removeChannel($channelId: ID!) {
    removeChannel(channelId: $channelId) {
      removed
    }
  }
`;
export default REMOVE_CHANNEL;
